import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import './editor.scss';
import MainComponent from './MainComponent';

export default function Edit() {
    return (
        <div { ...useBlockProps() }>
            <MainComponent />
        </div>
    );
}
